import {createStore} from 'vuex';
//import createPersistedState from "vuex-persistedstate";
import auth from './modules/auth';
import member from './modules/member';
import course from './modules/course';
import news from './modules/news';


const store = createStore({
    modules: {
        auth,
        member,
        course,
        news
    },
    state() {
        return {
            showLoginModal: false,
            showBaiLianModal:false,
            keyword: '',
        }
    },

    //mutations 是同步函数，用于改变 state 的值
    mutations: {
        /**
         * 全局登录 弹框
         * @param state
         */
        toggleLoginModal(state) {
            state.showLoginModal = !state.showLoginModal;
        },

        /**
         * 全局弹框 百炼窗口
         * @param state
         */
        toggleBaiLianModal(state) {
            state.showBaiLianModal = !state.showBaiLianModal;
        },

        /**
         * 搜索关键词
         * @param state
         * @param keyword
         */
        updateKeyword(state, keyword) {
            state.keyword = keyword;
        },
    },
    //建议使用 actions 来提交 mutations。actions 可以包含任意异步操作
    actions: {
        /**
         * 异步操作 登录框
         * @param commit
         */
        toggleLoginModal({commit}) {
            commit('toggleLoginModal');
        },

        /**
         * 异步操作 百炼窗口
         * @param state
         */
        toggleBaiLianModal({commit}) {
            commit('toggleBaiLianModal');
        },

    },
    // 使用 插件
    plugins: [
        // createPersistedState({
        //     storage: window.localStorage, // 默认是 localStorage
        //     key:  'this_token_account', // 你想要存储数据的键（默认是 'vuex'）
        //     reducer(state) {
        //         return {
        //             // 保存 auth 模块的 token，其他的状态不会被持久化
        //             token: state.auth.token,
        //             // 保存 auth 模块的 account，其他的状态不会被持久化
        //             account: state.auth.account
        //         };
        //     }
        // })
    ],

})

export default store
